import { connect } from 'react-redux'
import Option from './Option'

const mapStateToProps = (state, props) => ({
  name: state.branches[props.id].name,
})

export default connect(mapStateToProps)(Option)



// WEBPACK FOOTER //
// ./src/modules/BranchSelect/Option/Container.js